import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const seloDemolidor: TechniqueDefinition = {
  id: "selo_demolidor",
  name: "Selo Demolidor",
  description:
    "Sets a powerful proximity trap with greater damage and area than the Proximity Seal, at a higher chakra cost and cooldown.",
  family: "fuinjutsu",
  proficiency: "ninjutsu",
  targeting: "single_hostile",
  behavior: { kind: "trap" },
  deployment: {
    kind: "proximity_trap",
    armingTimeMs: 500,
    lifetimeMs: 20_000,
    activeLimitPerCaster: 1,
    recast: "replace",
    placement: "target_position",
  },
  levels: {
    1: {
      chakraCost: 34,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 18,
      attackCoefficient: 1.35,
      triggerRadius: 44,
      explosionRadius: 72,
    },
    2: {
      chakraCost: 35,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 19,
      attackCoefficient: 1.39,
      triggerRadius: 46,
      explosionRadius: 74,
    },
    3: {
      chakraCost: 36,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 20,
      attackCoefficient: 1.44,
      triggerRadius: 48,
      explosionRadius: 76,
    },
    4: {
      chakraCost: 37,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 22,
      attackCoefficient: 1.48,
      triggerRadius: 50,
      explosionRadius: 78,
    },
    5: {
      chakraCost: 38,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 23,
      attackCoefficient: 1.53,
      triggerRadius: 52,
      explosionRadius: 80,
    },
    6: {
      chakraCost: 40,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 24,
      attackCoefficient: 1.57,
      triggerRadius: 54,
      explosionRadius: 82,
    },
    7: {
      chakraCost: 41,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 25,
      attackCoefficient: 1.62,
      triggerRadius: 55,
      explosionRadius: 84,
    },
    8: {
      chakraCost: 42,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 26,
      attackCoefficient: 1.66,
      triggerRadius: 56,
      explosionRadius: 86,
    },
    9: {
      chakraCost: 43,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 27,
      attackCoefficient: 1.71,
      triggerRadius: 57,
      explosionRadius: 88,
    },
    10: {
      chakraCost: 44,
      cooldownMs: 12_000,
      range: 160,
      maxTargets: 5,
      power: 28,
      attackCoefficient: 1.75,
      triggerRadius: 58,
      explosionRadius: 90,
    },
  },
  visual: {
    effectId: 225,
    castEffectId: null,
    trapEffectId: 458,
    explosionEffectId: 225,
    areaImpactEffectId: 225,
    impactEffectId: null,
  },
};
